import type { MissionStatusCode, OperationStatusCode } from '@killer-party/contracts';

const MISSION_BADGES: Record<MissionStatusCode, string> = {
  READY: 'badge',
  STARTED: 'badge badge--red',
  SUCCEEDED: 'badge badge--gold',
  FAILED: 'badge badge--muted',
  ABORTED: 'badge badge--muted',
};

const OPERATION_BADGES: Record<OperationStatusCode, string> = {
  DRAFT: 'badge badge--muted',
  VALIDATED: 'badge',
  STARTED: 'badge badge--red',
  COMPLETE: 'badge badge--success',
};

// Classes du tampon de statut d'une mission (fiche d'effectif, classements, agents).
export function missionBadge(statusCode: MissionStatusCode): string {
  return MISSION_BADGES[statusCode];
}

// Classes du tampon de statut d'une operation (back-office).
export function operationBadge(statusCode: OperationStatusCode): string {
  return OPERATION_BADGES[statusCode];
}
